import React from 'react'
import { ButtonProps, Button as MantineButton } from '@mantine/core'

interface IProps extends ButtonProps {
  children: React.ReactNode
  className?: string
  onClick?: (event: React.MouseEvent<HTMLElement>) => void
}

export const Button: React.FC<IProps> = ({ children, className, ...props }) => {
  return <MantineButton {...props}>{children}</MantineButton>
}
